<template>
  <div
    v-if="formattedDateTimeArray.length === 2"
    class="flex"
    :class="{ 'flex-col': showTimeBelowDate }"
  >
    <div
      class="whitespace-nowrap"
      :class="showTimeBelowDate ? 'text-label' : 'text-headline'"
      :data-cy="showTimeBelowDate ? 'date' : 'time'"
    >
      {{ formattedDateTimeArray[0] }}
    </div>
    <span v-if="dateTimeDivider">{{ dateTimeDivider }}</span>
    <div
      ref="dateRef"
      v-tooltip="{
        content: dateTimeTooltipValue,
        onShow: () => isDateTruncated,
      }"
      :class="
        showTimeBelowDate
          ? 'text-headline'
          : 'ml-1 truncate whitespace-nowrap text-label'
      "
      :data-cy="showTimeBelowDate ? 'time' : 'date'"
    >
      {{ formattedDateTimeArray[1] }}
    </div>
  </div>
  <div v-else data-cy="placeholder">-</div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import { formatDateCustom } from "@/helpers/formatting";
import { useElementStatus } from "@/hooks/elements";

const { isTextTruncated } = useElementStatus();

const { value, showTimeBelowDate = true } = defineProps<{
  value: string | null;
  showTimeBelowDate?: boolean;
}>();

const dateRef = ref<HTMLElement | null>(null);
const isDateTruncated = isTextTruncated(dateRef);

const formattedDateTimeArray = computed(() => {
  if (!value) {
    return [];
  }

  const format = showTimeBelowDate
    ? "MMMM dd, yyyy|hh:mm a"
    : "hh:mm a|MMMM dd, yyyy";

  const formattedDateTime = formatDateCustom(value, format, true);

  return formattedDateTime.split("|");
});

const dateTimeDivider = computed(() => (showTimeBelowDate ? "" : ","));

const dateTimeTooltipValue = computed(() => {
  if (!value) {
    return "";
  }

  return formattedDateTimeArray.value.join(" ");
});
</script>
